import { Skeleton } from "primereact/skeleton";
import { skeletonProps } from "./skeleton.interface";

const SkeletonC = ({
  width,
  height,
  borderRadius,
  shape,
  size,
  className,
  style
}: skeletonProps) => {
  return (
    <Skeleton
      style={{ ...style }}
      width={width}
      height={height}
      borderRadius={borderRadius}
      shape={shape}
      size={size}
      className={className}
    />
  );
};

export default SkeletonC;
